import { differenceBy, orderBy, uniq, uniqBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { hasValue } from 'utils/NumberUtil'
import DatePicker from '../../../components/forms/DatePicker'
import Input from '../../../components/forms/Input'
import RadioButtons from '../../../components/forms/RadioButtons'
import Select from '../../../components/forms/Select'
import AdesStationDto from '../../../import/dto/AdesStationDto'
import Job from '../../../import/dto/DtoJob'
import StationAction from '../../../quality/actions/QualityAction'
import DtoEsu from '../../../quality/dto/DtoEsu'
import ContributorAction from '../../../referencial/components/contributor/actions/ContributorAction'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import NetworkAction from '../../../referencial/components/network/actions/NetworkAction'
import NetworkDto from '../../../referencial/components/network/dto/NetworkDto'
import { readImportCsvStationsCodes } from '../../../import/components/utils/ImportUtils'
import { Button, Grid } from '@mui/material'
import { CardTable } from '../../../components/datatable/NewTable'
import { exportFile } from '../../../utils/ExportDataUtil'
import { darkBlue, mainWhite } from '../../../utils/constants/ColorTheme'

class ExportQuesu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filters: this.getJsonFilters(props.job.parameters.filters),
            codeBss: '',
            codeNetwork: '',
        }
    }

    componentDidMount() {
        if (!this.props.networks.length) {
            this.props.fetchNetworks()
        }
        if (!this.props.contributors.length) {
            this.props.fetchContributor()
        }
        if (!this.props.stationsEsu.length) {
            this.props.fetchEsuLight()
        }
    }

    getJsonFilters = filters => {
        return filters.length !== 0 ? JSON.parse(filters[0]) : {}
    }

    onDeleteBssCode = ({ bsscode }) => {
        if (this.props.isEditMode) {
            const codes = this.props.job.parameters.parameters.filter(p => p != bsscode)
            this.props.addBssCode(codes)
        }
    }

    addCodeBss = () => {
        if (this.props.isEditMode) {
            const { codeBss } = this.state
            const exist = this.props.job.parameters.parameters.find(p => p.toLowerCase() == codeBss.toLowerCase())
            const esu = this.props.stationsEsu.find(s => s.codebss.toLowerCase() == codeBss.toLowerCase())
            if (!codeBss) {
                this.props.toastError(i18n.youMustEnterAtLeastOneBssCode)
            } else if (exist) {
                this.props.toastError(i18n.youHaveAlreadyEnteredThisBssCode)
            } else if (!esu) {
                this.props.toastError(`${i18n.itsNotaStationEsu} ${codeBss}`)
            } else {
                this.props.addBssCode([codeBss, ...this.props.job.parameters.parameters])
                this.setState({ codeBss: '' })
            }
        }
    }

    addNetworkCode = () => {
        const { codeNetwork } = this.state
        const stationFiltered = this.props.stationsEsu.filter(s => s.codereseau == codeNetwork)
        const newCodes = stationFiltered.map(s => s.codebss)
        this.props.addBssCode(uniq([...this.props.job.parameters.parameters, ...newCodes]))
        this.setState({ codeNetwork: '' })
    }

    onChangeBssFile = e => {
        if (this.props.isEditMode) {
            readImportCsvStationsCodes(e, this.refs, (codes) => {
                const notEsu = differenceBy(codes, this.props.stationsEsu.map(s => s.codebss), s => s.toLowerCase())
                if (notEsu.length) {
                    this.props.toastError(`${i18n.itsNotaStationEsu} ${notEsu[0]}`)
                } else {
                    this.props.addBssCode(uniqBy([...this.props.job.parameters.parameters, ...codes], s => s.toLowerCase()))
                }
            })
        }
    }

    getStations = () => {
        return this.props.job.parameters.parameters.map(bsscode => new AdesStationDto({ bsscode }))
    }

    onChangeJobParameter = (changes) => {
        const jobParameters = {
            ...this.props.job.parameters,
            ...changes,
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}

    getFilter = key => hasValue(this.state.filters[key]) ? this.state.filters[key] : ''

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const contributorsFiltered = this.props.contributors.filter(r => r.siret).map((c) => {
            return {
                ...c,
                labelAutocomplete: `${c.name} - ${c.siret}`,
            }
        })
        const contributorsFormatted = orderBy(contributorsFiltered, 'labelAutocomplete')
        const exportModes = [
            { code: 'ALL', name: 'Exporter tout l\'historique' },
            { code: 'CUSTOM', name: `${i18n.choiseDate}` },
        ]
        const selectStationsMode = [
            { code: 'IMPORT', name: 'Choisir par import' },
            { code: 'STATION', name: 'Choisir une station' },
            { code: 'RESEAU', name: 'Choisir un reseau' },
        ]
        const typeExportQuesu = [
            { code: 'STA', name: 'Station et point (Prochainement)' },
            { code: 'PHY', name: 'Physico-chimie' },
            { code: 'BIO', name: 'Biologie (Prochainement)' },
        ]
        const filters = this.getFilters()

        return (
            <>
                <Grid container spacing={1}>
                    <Grid size={3}>
                        <Input
                            title={i18n.exportDirectory}
                            value={this.props.job.parameters.path} obligatory
                            onChange={v => this.onChangeJobParameter({ path: v })}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            options={exportModes}
                            label={i18n.exportMode}
                            onChange={v => this.onChangeFilters({ mode: v })}
                            obligatory
                            value={filters.mode}
                            {...disabled}
                        />
                    </Grid>
                    {
                        filters.mode === 'CUSTOM' ? [
                            // eslint-disable-next-line react/jsx-key
                            <Grid size={1.5}>
                                <DatePicker
                                    title={i18n.startDate}
                                    value={filters.startDate}
                                    onChange={(_, v) => this.onChangeFilters({ startDate: v })}
                                    {...disabled}
                                />
                            </Grid>,
                            // eslint-disable-next-line react/jsx-key
                            <Grid size={1.5}>
                                <DatePicker
                                    title={i18n.endDate}
                                    value={filters.endDate}
                                    onChange={(_, v) => this.onChangeFilters({ endDate: v })}
                                    {...disabled}
                                />
                            </Grid>,
                        ] : <Grid size={3} />
                    }
                    <Grid size={3}>
                        <Input
                            title={i18n.emailWithData}
                            value={filters.email}
                            onChange={v => this.onChangeFilters({ email: v })}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={`${i18n.sender} - ${i18n.siretNumber}`}
                            value={filters.idNumberEmetteur}
                            options={contributorsFormatted}
                            keyValue='id'
                            obligatory
                            keyLabel='labelAutocomplete'
                            onChange={(id, contributor) => this.onChangeFilters({ idNumberEmetteur: id, siretNumberEmetteur: contributor.siret })}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            multiple
                            options={contributorsFormatted}
                            values={filters.idProducteur?.length ? filters.idProducteur : []}
                            onChange={values => {
                                this.onChangeFilters({ idProducteur: values })
                            }}
                            label={`${i18n.filter} - ${i18n.byProducer}`}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            label={`${i18n.receiver} - ${i18n.siretNumber}`}
                            values={this.getFilter('idNumberDestinataire')}
                            options={contributorsFormatted}
                            keyValue='id'
                            obligatory
                            keyLabel='labelAutocomplete'
                            onChange={idContributor => {
                                const { contributors } = this.props
                                const siret = contributors.find(c => c.id === idContributor)?.siret
                                return this.onChangeFilters({ idNumberDestinataire: idContributor, siretNumberDestinataire: siret })
                            }}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={6} />
                    <Grid size={6}>
                        <fieldset className='width-50' >
                            <legend >&nbsp;{i18n.selectStations}&nbsp;</legend>
                            <RadioButtons
                                elements={selectStationsMode}
                                selected={filters.selectStationsMode || 'FILTERS'}
                                onChange={v => this.onChangeFilters({ selectStationsMode: v })}
                                {...disabled}
                            />
                        </fieldset>
                    </Grid>
                    <Grid size={6}>
                        <fieldset className='width-50'>
                            <legend>&nbsp;{i18n.type}&nbsp;</legend>
                            <RadioButtons
                                elements={typeExportQuesu}
                                selected={filters.typeExportQuesu || 'PHY'}
                                onChange={v => this.onChangeFilters({ typeExportQuesu: v })}
                                disabled='true'
                            />
                        </fieldset>
                    </Grid>
                    <Grid size={12}>
                        {
                            filters.selectStationsMode === 'IMPORT' ? (
                                <Grid container spacing={2} className='padding-bottom-1'>
                                    <Grid size={3}>
                                        <label>{i18n.importFile}</label>
                                    </Grid>
                                    <Grid size={9}>
                                        <Grid container spacing={2} alignItems='center'>
                                            <Grid size={3}>
                                                <Button
                                                    variant='contained'
                                                    component='label'
                                                    fullWidth
                                                    {...disabled}
                                                >
                                                    {i18n.importStations}
                                                    <input
                                                        type='file'
                                                        hidden
                                                        ref='importFile'
                                                        accept='.csv'
                                                        onChange={this.onChangeBssFile}
                                                        {...disabled}
                                                    />
                                                </Button>
                                            </Grid>
                                            <Grid size={9}>
                                                <input className='file-path' ref='fileInput' type='text' placeholder={i18n.selectedFile}{...disabled} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ) : (
                                !filters.selectStationsMode || filters.selectStationsMode === 'STATION' ? (
                                    <Grid container spacing={1}>
                                        <Grid size={4}>
                                            <Input
                                                id='txtAddBssCode'
                                                type='text'
                                                title={i18n.stationCode}
                                                onChange={v => this.setState({ codeBss: v })}
                                                value={this.state.codeBss}
                                                ref='txtAddBssCode'
                                                {...disabled}
                                            />
                                        </Grid>
                                        <Button
                                            variant='contained'
                                            onClick={this.addCodeBss}
                                            {...disabled}
                                        >
                                            {i18n.add}
                                        </Button>
                                    </Grid>
                                ) : (
                                    <Grid container spacing={1}>
                                        <Grid size={4}>
                                            <Select
                                                options={orderBy(this.props.networks, 'name')}
                                                label={i18n.importStationByNetwork}
                                                value={this.state.codeNetwork}
                                                onChange={r => this.setState({ codeNetwork: r })}
                                                {...disabled}
                                            />
                                        </Grid>
                                        <Button
                                            variant='contained'
                                            onClick={this.addNetworkCode}
                                            {...disabled}
                                        >
                                            {i18n.add}
                                        </Button>
                                    </Grid>
                                )
                            )
                        }
                    </Grid>
                    <Grid size={12}>
                        <CardTable
                            title={i18n.identifiants}
                            rows={this.getStations()}
                            headers={['stationCode']}
                            color={darkBlue}
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: this.getStations(),
                                    titleFile: i18n.credentials,
                                }),
                                color: mainWhite,
                                tooltip: i18n.download,
                            }]}
                            lineActions={[{
                                icon: 'delete',
                                onClick: (s) => this.onDeleteBssCode(s),
                                displayed: this.props.isEditMode,
                            }]}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
}

ExportQuesu.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    networks: PropTypes.arrayOf(NetworkDto),
    isEditMode: PropTypes.bool,
    addBssCode: PropTypes.func.isRequired,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func.isRequired,
    onChangeEmails: PropTypes.func,
    toastError: PropTypes.func,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    stationsEsu: PropTypes.arrayOf(PropTypes.instanceOf(DtoEsu)),
}

const mapDispatchToProps = {
    toastError: ToastrAction.error,
    fetchNetworks: NetworkAction.fetchNetworks,
    fetchContributor: ContributorAction.fetchContributors,
    fetchEsuLight: StationAction.fetchEsuLight,
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
    networks: store.NetworkReducer.networks,
    stationsEsu: store.QualityReducer.stationsEsu,
})

export default connect(mapStateToProps, mapDispatchToProps)(ExportQuesu)
